import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

function Cover(props) {
  const {
    className,
    children
  } = props;
  const containerRef = React.useRef(null);
  const callbackRef = React.useRef();
  React.useEffect(() => {
    if (callbackRef.current) {
      window.cancelIdleCallback(callbackRef.current);
    }

    const {
      current: el
    } = containerRef;

    if (el && el.parentElement) {
      const {
        style
      } = el.parentElement;
      const {
        position,
        zIndex
      } = style;

      if (!zIndex) {
        styles.zIndex = '0';
      }

      if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') {
        el.parentElement.style.position = 'relative';
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.cover, className),
    ref: containerRef
  }, children);
}

var Cover$1 = genericMemo(Cover);

export { Cover$1 as default };
//# sourceMappingURL=index.js.map
